import { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import CruiseSearchInputs from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchInputs'
import { useAppDispatch, useAppSelector, shallowEqual } from 'hooks/reduxHooks'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import useQueryParams from 'hooks/useQueryParams'
import { getCruiseSearchFiltersBar } from 'lib/cruises/cruiseUtils'
import { pushWithCruiseFilters } from 'actions/CruiseActions'

interface Props {
  disableAutoFocus?: boolean
  hideCruiseLine?: boolean
}

const CruiseInputsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${rem(16)};
`

function CruisesTabContent({ disableAutoFocus, hideCruiseLine }: Props) {
  const dispatch = useAppDispatch()
  const globalSearch = useContext(GlobalSearchStateContext)
  const { pathname, regionCode } = useAppSelector(state => {
    return {
      pathname: state.router.location.pathname,
      regionCode: state.geo.currentRegionCode,
    }
  }, shallowEqual)
  const queryParams = useQueryParams()

  const onChange = useCallback((values: App.CruiseGlobalFilters) => {
    const { pageName, filters } = getCruiseSearchFiltersBar(values, globalSearch, pathname, regionCode)
    dispatch(pushWithCruiseFilters(pageName, filters, queryParams))
  }, [globalSearch, pathname, regionCode, dispatch, queryParams])

  const inputs = <CruiseSearchInputs
    drawerMode
    onChange={onChange}
    disableAutoFocus={disableAutoFocus}
    hideCruiseLine={hideCruiseLine}
  />

  return <Group direction="vertical" gap={16}>
    <CSSBreakpoint max="mobile">
      <CruiseInputsGrid>{inputs}</CruiseInputsGrid>
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet">
      {inputs}
    </CSSBreakpoint>
  </Group>
}

export default CruisesTabContent
